import React from 'react';
import { getTheme, mergeStyleSets, Stack, TagItem, Text } from 'office-ui-fabric-react';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const wrapperStyles = {
  root: {
    background: getTheme().palette.neutralLighter,
    height: 30,
    paddingLeft: 10
  }
};
export const FilterTagPicker = _ref => {
  let {
    filterName,
    dataId,
    tags,
    onRemoveItem,
    styles,
    isDisabled,
    tagStyles,
    labelStyles
  } = _ref;
  return /*#__PURE__*/_jsxs(Stack, {
    horizontal: true,
    verticalAlign: "center",
    tokens: {
      childrenGap: 10
    },
    "data-id": dataId,
    styles: mergeStyleSets(wrapperStyles, styles),
    children: [/*#__PURE__*/_jsxs(Text, {
      styles: labelStyles,
      children: [filterName, ":"]
    }), tags.map((tag, index) => /*#__PURE__*/_jsx(TagItem, {
      disabled: isDisabled,
      item: tag,
      styles: tagStyles,
      index: index,
      onRemoveItem: () => onRemoveItem(tag),
      children: tag.name
    }, tag.key))]
  });
};